import React, { useMemo } from "react";
import { SmoothScroll, EnquiryProvider } from "../lib/site-ui";
import Seo from "../components/Seo";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { CourseMarquee } from "../components/site/CourseMarquee";
import { Courses } from "../components/site/Courses";
import { Pricing } from "../components/site/Pricing";
import { FreeDemo } from "../components/site/FreeDemo";
import { LearnYourWay, WhyAeroVaid } from "../components/site/LearnWhy";
import { Founder, Trust } from "../components/site/Founder";
import { SeoContent } from "../components/site/SeoContent";
import { Faq, Contact, Footer } from "../components/site/FaqContact";
import { WhatsAppFloat } from "../components/site/WhatsAppFloat";
import { ORG_JSONLD, WEBSITE_JSONLD, faqJsonLd, FAQS } from "../config/site";

export default function Landing() {
  const jsonLd = useMemo(() => [ORG_JSONLD, WEBSITE_JSONLD, faqJsonLd(FAQS)], []);
  return (
    <EnquiryProvider>
      <Seo
        title="AeroVaid Aviation Academy | DGCA Coaching in India."
        description="AeroVaid Aviation Academy offers DGCA ground classes in Mumbai and online across India. Prepare for DGCA exams with structured aviation coaching."
        path="/"
        jsonLd={jsonLd}
      />
      <SmoothScroll />
      <div className="grain" />
      <div className="bg-slate-950 min-h-screen relative">
        <Navbar />
        <main>
          <Hero />
          <CourseMarquee />
          <Courses />
          <Pricing />
          <FreeDemo />
          <LearnYourWay />
          <WhyAeroVaid />
          <Founder />
          <Trust />
          <SeoContent />
          <Faq />
          <Contact />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </EnquiryProvider>
  );
}
